(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["bromad-custom-filter"] && !Shopify.designMode) return;
  try {
    const tabs = document.querySelectorAll('.category-tab-data');
  const products = document.querySelectorAll('.br-product');
  let currentActiveFilters = [];
  let categoryFilter = "All";

  function setFiltering() {
    tabs.forEach((tab) => {
      tab.addEventListener('click', function () {
        setClass(tabs, this.id);
        categoryFilter = this.dataset.categoryTag;
        filterProduct(categoryFilter);
      });
    });
  }


  function setClass(elemClass, elemId) {
    elemClass.forEach((elem) => {
      if (elem.id == elemId) {
        elem.classList.add('active');
      } else {
        elem.classList.remove('active');
      }
    });
  }

  function filterProduct(categoryFilter) {
  // function filterProduct(categoryTag, activeFilters = []) {
    let visibleCount = 0;
    products.forEach((product) => {
      // const productCategory = product.dataset.categoryTag;
      const filterTags = product.dataset.filterTags ? product.dataset.filterTags.split(',') : [];
      console.log("filterTags",filterTags);

      const matchesFilters = categoryFilter == "All" || filterTags.includes(categoryFilter);
      console.log(product.id + " - " + matchesFilters);

      if (matchesFilters) {
        product.style.display = 'block';
        visibleCount++;
      } else {
        product.style.display = 'none';
      }
    });

    const noProductsMsg = document.getElementById('no-products-message');
    if (noProductsMsg) {
      noProductsMsg.classList.toggle('hidden', visibleCount !== 0);
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    setFiltering();
  });
  } catch(e) { console.error(e); }
})();

})();
